// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
}

.title h3{
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: left;
}

.error-message {
  color: red;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

th {
  background-color: #0b2d71 !important; 
  color: white !important; 
  font-weight: bold;
}

td a {
  color: blue; 
  text-decoration: none;
}

td a:hover {
  text-decoration: underline;
}

.mat-elevation-z8 {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.mat-paginator {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.employee-details-table {
  width: 50%;
  margin: 0 auto;
  border-collapse: collapse;
}

.employee-details-table td {
  padding: 5px 10px;
  border: 1px solid #ddd;
}

.employee-details-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.employee-details-table tr:hover {
  background-color: #ddd;
}

.employee-details-table td strong {
  white-space: nowrap;
}

.form-border {
  border: 1px solid #d3d3d3;
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
}

.bordered-container {
  border: 1px solid #d3d3d3; 
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
  padding-bottom: 1%;
}

.small-button {
  padding: 7px 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/doa-log-report/doa-log-report.component.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2HAA2H;AAC7H;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n}\n\n.title h3{\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: left;\n}\n\n.error-message {\n  color: red;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth,\ntd {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\nth {\n  background-color: #0b2d71 !important; \n  color: white !important; \n  font-weight: bold;\n}\n\ntd a {\n  color: blue; \n  text-decoration: none;\n}\n\ntd a:hover {\n  text-decoration: underline;\n}\n\n.mat-elevation-z8 {\n  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.mat-paginator {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.employee-details-table {\n  width: 50%;\n  margin: 0 auto;\n  border-collapse: collapse;\n}\n\n.employee-details-table td {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n}\n\n.employee-details-table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.employee-details-table tr:hover {\n  background-color: #ddd;\n}\n\n.employee-details-table td strong {\n  white-space: nowrap;\n}\n\n.form-border {\n  border: 1px solid #d3d3d3;\n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n}\n\n.bordered-container {\n  border: 1px solid #d3d3d3; \n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n  padding-bottom: 1%;\n}\n\n.small-button {\n  padding: 7px 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
